import { addDataLayerEntry, Events } from '@printdeal/data-layer-manager';
import { hotjarEvent } from '../../../../helpers/HotjarHelper';
import type { NavigationItem } from '../../types';
import type { AudiencesData } from '../../../../templates/homepage/homepage-helper';

const Actions = {
  click: 'click',
  show: 'show',
};

interface DataProps {
  navType: string;
  eventLabel: string;
  eventActionShow?: boolean;
}

export const dispatchDataLayerEventOnNavigationView = (data: DataProps) => {
  const { navType, eventLabel } = data;
  // GA3
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory: navType,
      eventAction: Actions.show,
      eventLabel,
      eventNonInteraction: true,
    },
  });
  // GA4
  addDataLayerEntry(navType, {
    eventAction: Actions.show,
    eventLabel,
    eventNonInteraction: true,
  });
};

export const dispatchNavigationHotjarEvent = () => hotjarEvent('Navigation_ListViewed');

export const addEventLabelForBadges = (badgeKind: string, eventLabel: string, badgeTitle: string) => {
  if (badgeKind) {
    return `${eventLabel}_badge-${badgeKind}_${badgeTitle}`.toLowerCase();
  }
  return eventLabel;
};

/**
*
* This function filters the navigation items based on the audience type.
* We get from Contentful a string with comma separated audiences,
* we have to split it and get the first value. We are planning to operate multiple audiences in the future.
* @param navItems from Contentful
* @param customerAudienceType from Segmentation
* @returns audience specific navigation items
*/
export const excludeNonRelevantNavItemsPerAudience = (
  navItems: NavigationItem[] | undefined,
  customerAudienceType: AudiencesData['type'],
) => navItems?.filter((item) => {
  const audienceType = item.audienceType ? item.audienceType.split(',')[0] : item.audienceType;
  return audienceType === customerAudienceType || item.audienceType === null;
});
